var React = require('react');

function Shape5 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.41952 67.0911C25.5554 12.0115 71.6157 -15.1198 117.295 8.63367C140.842 20.8373 155.512 43.9733 162.847 66.7643C170.055 89.9548 169.927 112.8 161.031 133.485C151.463 154.496 133.308 165.083 113.137 170.731C92.7668 176.106 70.4175 176.542 47.941 171.258C3.4057 158.673 -9.23048 121.227 6.41952 67.0911Z"}));
}

Shape5.defaultProps = {"width":"168","height":"175","viewBox":"0 0 168 175","fill":"none"};

module.exports = Shape5;

Shape5.default = Shape5;
